import {Component, Directive, OnDestroy} from "@angular/core";
import {FormService} from "../services/form.service";
import {Observable} from "rxjs";
import {Order, StandardName} from "../../store/state/order.state";

@Directive()
export abstract class BaseSubFormComponent implements OnDestroy {

	protected constructor(private fs: FormService) {
	}

	abstract getFormKey(): string;

	/**
	 * Use in case when form service is determined in the OnInit method or passed via @Input
	 */
	setFormService(formService: FormService) {
		this.fs = formService;
	}

	ngOnDestroy(): void {
		this.fs.destroySubForm(this.getFormKey());
	}

	isInvalid(controlName: string): boolean {
		return this.fs.isInvalid(this.getFormKey(), controlName);
	}

	getValidationErrors(controlName: string): Observable<string> {
		return this.fs.getErrorsString(this.getFormKey(), controlName);
	}

	updateFormControl(controlName: string, value: any) {
		this.fs.updateFormControl(controlName, value, this.getFormKey());
	}

	fullControlName(controlNamePrefix: string) {
		return controlNamePrefix + this.getFormKey();
	}

	totalSubForms(order: Order): number {
		let hasIso27k: boolean = order.products.filter(p => [StandardName.ISO_27001, StandardName.ISO_27701].includes(p.standard.name)).length == 2;
		return hasIso27k && !this.iso27701HasItsOwnSubForm() ?
			order.products.length - 1 :
			order.products.length;
	}

	protected abstract iso27701HasItsOwnSubForm(): boolean;
}
